import { queryClient, useMutation } from '../../../../ReactQuery';
import { remove } from '../../../../redux/api';
import { getApiWebhookSettingsQueryKey } from './useGetApiWebhookSettings';
import { window } from '../../../../globals';

function deleteApiWebhook(orgId: number, webhookId: number) {
  return remove<{ id: number }, null>(`/api/organizations/${orgId}/settings/integrations/api-webhooks`, { body: { id: webhookId }, json: true });
}

/**
 * Creates a mutation that deletes an API webhook setting for the org.
 */
export default function useDeleteApiWebhookSetting(webhookId: number) {
  return useMutation({
    mutationFn: () => deleteApiWebhook(window.user?.organizationId ?? 0, webhookId),
    onSuccess: () => {
      queryClient.invalidateQueries(getApiWebhookSettingsQueryKey(window.user?.organizationId ?? 0));
    },
  });
}
